import { render, staticRenderFns } from "./PosthogEventsTable.vue?vue&type=template&id=35d21e94"
import script from "./PosthogEventsTable.vue?vue&type=script&lang=js"
export * from "./PosthogEventsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports